"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuIcon = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BurgerMenuIcon = () => {
  const [menuIsOpen, toggleMenu] = (0, _hooks.useToggleMenu)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const ownerState = {
    isOpen: menuIsOpen
  };
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuIconRoot, {
    disableRipple: true,
    "aria-label": formatMessage('menu'),
    ownerState: ownerState,
    "data-testid": getTestId(_constants.BURGER_MENU),
    id: "main-menu",
    onClick: toggleMenu,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuIconWrapper, {
      ownerState: {
        ...ownerState,
        isMobile: true
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BurgerMenuIconWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuIconLine, {
        ownerState: ownerState,
        className: "burgerMenuIconLine"
      })]
    })]
  });
};
exports.BurgerMenuIcon = BurgerMenuIcon;
